<template>
  <div>
    <h2 class="mt-6 mb-6">
      {{ machine.serial_number }}
      <br />
      {{ machine.name }}
    </h2>
    <h3 class="mb-3">卡機結帳紀錄</h3>

    <v-data-table
      :headers="thead"
      :items="settlements"
      :items-per-page.sync="pagination.items"
      :page.sync="pagination.page"
      :footer-props="{
        'items-per-page-options': [50, 100, 200, 300, 500]
      }"
      :server-items-length="pagination.total"
    >
      <template v-slot:item.no="{ item }">
        <span class="blue--text">{{ item.no }}</span>
      </template>
    </v-data-table>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";

import PaginationMixin from "@/mixins/Pagination";

import machineApi from "@/api/machine";

export default {
  components: {},

  mixins: [PaginationMixin],

  props: ["id"],
  data() {
    return {
      machine: {},
      settlements: [],

      thead: [
        {
          text: "",
          value: "no",
          align: "center"
        },
        {
          text: "結帳日期",
          value: "settle_date",
          align: "center",
          width: "120px"
        },
        {
          text: "結帳時間",
          value: "settle_time",
          align: "center",
          width: "120px"
        },
        {
          text: "機器序號",
          value: "serial_number",
          align: "center"
        },
        {
          text: "信用卡筆數",
          value: "credit_card_count",
          align: "right"
        },
        {
          text: "信用卡金額",
          value: "credit_card_amount",
          align: "right"
        },
        {
          text: "悠遊卡筆數",
          value: "easy_card_count",
          align: "right"
        },
        {
          text: "悠遊卡金額",
          value: "easy_card_amount",
          align: "right"
        },
        {
          text: "一卡通筆數",
          value: "ipass_count",
          align: "right"
        },
        {
          text: "一卡通金額",
          value: "ipass_amount",
          align: "right"
        },
        {
          text: "愛金卡筆數",
          value: "icash_count",
          align: "right"
        },
        {
          text: "愛金卡金額",
          value: "icash_amount",
          align: "right"
        },
        {
          text: "遠鑫卡筆數",
          value: "happycash_count",
          align: "right"
        },
        {
          text: "遠鑫卡金額",
          value: "happycash_amount",
          align: "right"
        },
        {
          text: "通訊回應碼",
          value: "ecr_response_code",
          align: "center"
        },
        {
          text: "EDC 商店",
          value: "edc_merchant",
          align: "center"
        },
        {
          text: "EDC 終端機",
          value: "edc_terminal",
          align: "center"
        }
      ]
    };
  },

  computed: {},
  watch: {},
  methods: {
    getList() {
      this.paginationInProgress = true;

      machineApi
        .getSettlements(this.id, this.pagination.items, this.pagination.page)
        .then(res => {
          this.machine = res.machine;
          this.settlements = res.settlements;

          this.settlements.forEach((item, idx) => {
            item.no =
              idx + 1 + this.pagination.items * (this.pagination.page - 1);
          });

          this.pagination.total = res.number_of_settlements;

          this.paginationInProgress = false;
        })
        .catch(err => {});
    }
  },

  mounted() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
</style>
